import { Icon } from '@winnin/winnin_ui.components.icon'
import { Title } from '@winnin/winnin_ui.components.title'

import { GRAPH_COLORS } from 'consts'
import { T } from 'lib/tolgee'
import { TOLGEE_GLOBALS, stringUtils } from 'utils'

import './index.scss'

const TOLGEE_PREFIX = 'Compare-ComparisonSelector'

function SubLabel({ type, item }) {
  if (type === 'topics') {
    if (item?.type === 'globalTopic') {
      return (
        <span className="type">
          <T keyName={TOLGEE_GLOBALS.musicTopics.key}>{TOLGEE_GLOBALS.musicTopics.defaultValue}</T>
        </span>
      )
    }

    if (!item?.language && ['topic', 'subtopic'].includes(item?.type)) {
      return (
        <span className="type">
          <T
            keyName={`${TOLGEE_PREFIX}-itemSublabelNoLanguage`}
            parameters={{
              language: languageLabel,
              type: stringUtils.upperFirstLetter(item?.type),
              parent: item?.topic || item?.category,
            }}
          >
            {'{type} in “{parent}”'}
          </T>
        </span>
      )
    }

    const languageMap = {
      eng: 'EN',
      por: 'PT',
      spa: 'ES',
      all: 'Music',
    }
    const languageLabel = languageMap?.[item?.language]

    if (item?.type === 'topic') {
      return (
        <span className="type">
          <T
            keyName={`${TOLGEE_PREFIX}-itemSublabel`}
            parameters={{
              language: languageLabel,
              type: stringUtils.upperFirstLetter(item?.type),
              parent: item?.category,
            }}
          >
            {'{language} - {type} in “{parent}”'}
          </T>
        </span>
      )
    }

    if (item?.type === 'subtopic') {
      return (
        <span className="type">
          <T
            keyName={`${TOLGEE_PREFIX}-itemSublabel`}
            parameters={{
              language: languageLabel,
              type: stringUtils.upperFirstLetter(item?.type),
              parent: item?.topic,
            }}
          >
            {'{language} - {type} in “{parent}”'}
          </T>
        </span>
      )
    }

    if (item?.type === 'SavedPostSearch') {
      if (!item?.query) return null
      return (
        <span className="type ellipsis">
          <T keyName={TOLGEE_GLOBALS.searchTerm.key}>{TOLGEE_GLOBALS.searchTerm.defaultValue}</T>: {item?.query}
        </span>
      )
    }
  }

  return null
}

function SelectedItems({ type, items, removeItem }) {
  const currentItems = [
    ...(items?.savedPostSearches || []),
    ...(items?.subtopics || []),
    ...(items?.topics || []),
    ...(items?.global_topic || []),
  ]

  return currentItems.map((item, index) => {
    if (!item?.value) {
      return null
    }

    return (
      <div key={item?.value} className="ComparisonSelector-SelectedItems">
        <div className="selected-content">
          <span className="bullet" style={{ backgroundColor: GRAPH_COLORS?.[index] }} />

          <span className="selected-label">
            <div className="label-container">
              <Title tag="h6" weight="regular" className="label">
                {item?.label}
              </Title>

              <SubLabel type={type} item={item} />
            </div>
          </span>

          {item?.isTrending && (
            <div className="trend">
              <Icon icon="trending" className="icon" />
            </div>
          )}

          <span onClick={() => removeItem(item)} className="close">
            <Icon icon="smallClose" fill="var(--gray)" />
          </span>
        </div>
      </div>
    )
  })
}

export default SelectedItems
